import React, { createContext, useContext } from "react";
import PropTypes from "prop-types";
import { ToastContainer, toast } from 'react-toastify';

export const NotificationContext = createContext({});

export const NotificationProvider = ({ children }) => {
  
  const notify = ({ place="bottom-left", title="", message="", type="default", autoDismiss=7, ...rest }) => {
    // Define toast position in react-toastify format
    const position = convertPosition(place);
    
    // Define toast type
    const toastType = convertType(type);
    
    // Create message
    const content = (
      <div className="alert-text">
        {title && (
          <span className="alert-title" data-notify="title">
            {title}
          </span>
        )}
        <span data-notify="message">
          {message}
        </span>
      </div>
    );
    
    // Check that toast[toastType] is a function before calling
    if (typeof toast[toastType] === 'function') {
      // Show toast
      toast[toastType](content, {
        position: position,
        autoClose: autoDismiss * 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        ...rest
      });
    } else {
      // Fallback using toast.info if toastType is not valid
      toast.info(content, {
        position: position,
        autoClose: autoDismiss * 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        ...rest
      });
    }
  };
  
  // Helper function for converting position.
  // react-toastify v11 removed toast.POSITION; positions are plain strings.
  const convertPosition = (place) => {
    switch(place) {
      case 'tl': return 'top-left';
      case 'tc': return 'top-center';
      case 'tr': return 'top-right';
      case 'bl': return 'bottom-left';
      case 'bc': return 'bottom-center';
      case 'br': return 'bottom-right';
      case 'bottom-left':
      case 'bottom-center':
      case 'bottom-right':
      case 'top-left':
      case 'top-center':
      case 'top-right':
        return place;
      default: return 'bottom-left';
    }
  };
  
  // Helper function for converting type
  const convertType = (type) => {
    switch(type) {
      case 'primary': return 'info';
      case 'secondary': return 'info';
      case 'success': return 'success';
      case 'danger': return 'error';
      case 'warning': return 'warning';
      case 'info': return 'info';
      case 'light': return 'info';
      case 'dark': return 'info';
      default: return 'info';
    }
  };
  
  return (
    <NotificationContext.Provider
      value={{
        notify,
      }}
    >
      {children}
      <ToastContainer />
    </NotificationContext.Provider>
  );
};

NotificationProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useNotification = () =>
  useContext(NotificationContext); 